import React from 'react';

const ListFilter = ({ children }) => (
  <form className="theme-filter" onSubmit={e => e.preventDefault()}>
    {children}
  </form>
);

export default ListFilter;
